import axios from 'axios';
import Pagination from '@/domain/pagination.entity';
import Response from '@/domain/response.entity'
import PaymentFileFilter from '../entity/payment-file-filter.entity';

export default class PaymentFileService {
  public static getPaymentesFiles(
    businessUnitId: string,
    filters: PaymentFileFilter,
    pagination: Pagination,
  ): Promise<Response> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/invoices/payment-file`, {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        sortBy: pagination.arrangeSortBy,
        competence: filters.competence ? filters.competence : null,
        customerCode: filters.customerCode ? filters.customerCode : null,
        customerName: filters.customerName ? filters.customerName : null,
        customerTradingName: filters.customerTradingName ? filters.customerTradingName : null,
      },
    })
      .then((response: any) => Response.of(response.data));
  }

  public static downloadPaymentFile(businessUnitId: string, paymentFileId: string): Promise<any> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/invoices/payment-file/${paymentFileId}`);
  }
}
